import { render } from "./TheThanhTichThiDauTheThao.vue?vue&type=template&id=7d52fb42"
import script from "./TheThanhTichThiDauTheThao.vue?vue&type=script&lang=js"
export * from "./TheThanhTichThiDauTheThao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__